(function () {
  function qs(sel, root = document) { return root.querySelector(sel); }

  function buildEmbed(url) {
    url = (url || "").trim();
    if (!url) return null;

    // YouTube
    if (url.includes("youtu")) {
      let id = "";
      const m1 = url.match(/youtu\.be\/([A-Za-z0-9_-]+)/);
      const m2 = url.match(/[?&]v=([A-Za-z0-9_-]+)/);
      const m3 = url.match(/youtube\.com\/embed\/([A-Za-z0-9_-]+)/);
      id = (m3 && m3[1]) || (m2 && m2[1]) || (m1 && m1[1]) || "";
      if (!id) return null;

      const iframe = document.createElement("iframe");
      iframe.src = `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`;
      iframe.allow = "autoplay; fullscreen; picture-in-picture";
      iframe.allowFullscreen = true;
      iframe.title = "Product video";
      return iframe;
    }

    // Vimeo
    if (url.includes("vimeo")) {
      const m = url.match(/vimeo\.com\/(\d+)/) || url.match(/player\.vimeo\.com\/video\/(\d+)/);
      const id = m && m[1];
      if (!id) return null;

      const iframe = document.createElement("iframe");
      iframe.src = `https://player.vimeo.com/video/${id}?autoplay=1`;
      iframe.allow = "autoplay; fullscreen; picture-in-picture";
      iframe.allowFullscreen = true;
      iframe.title = "Product video";
      return iframe;
    }

    // Direct video file
    if (/\.(mp4|webm|ogg)(\?.*)?$/i.test(url)) {
      const video = document.createElement("video");
      video.src = url;
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      return video;
    }

    // Fallback iframe
    const iframe = document.createElement("iframe");
    iframe.src = url;
    iframe.allow = "autoplay; fullscreen; picture-in-picture";
    iframe.allowFullscreen = true;
    iframe.title = "Product video";
    return iframe;
  }

  function openModal(modal, url, opener) {
    const wrap = qs(".ew-video-frame-wrap", modal);
    if (!wrap) return;

    wrap.innerHTML = "";
    const player = buildEmbed(url);
    if (!player) return;

    modal.__lastFocus = opener || document.activeElement;
    wrap.appendChild(player);

    modal.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";

    const closeBtn = qs(".ew-video-close", modal);
    if (closeBtn) closeBtn.focus();
  }

  function closeModal(modal) {
    const wrap = qs(".ew-video-frame-wrap", modal);
    if (wrap) wrap.innerHTML = "";

    modal.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";

    const last = modal.__lastFocus;
    if (last && typeof last.focus === "function") last.focus();
  }

  // Use CAPTURE so we win even if the theme stops propagation
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".ew-gallery-video-btn");
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const url = btn.getAttribute("data-video-url");
    const modalId = btn.getAttribute("aria-controls");
    const modal = modalId ? document.getElementById(modalId) : null;
    if (!url || !modal) return;

    openModal(modal, url, btn);
  }, true);

  document.addEventListener("click", function (e) {
    const closeHit = e.target.closest("[data-ew-close]");
    if (!closeHit) return;

    const modal = e.target.closest(".ew-video-modal");
    if (!modal) return;

    e.preventDefault();
    e.stopPropagation();
    closeModal(modal);
  }, true);

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    const modal = document.querySelector('.ew-video-modal[aria-hidden="false"]');
    if (!modal) return;
    e.preventDefault();
    closeModal(modal);
  });
})();
